export default "__VITE_ASSET__B$OcDqs7__"